import { FieldState, FormState } from 'formstate';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { observer } from 'mobx-react-lite';
import styles from '@components/CreativeModalContent/CreativeModalAddProject.style';
import Input from '@components/Input/Input';
import Textarea from '@components/Textarea/Textarea';
import Button from '@components/Button/Button';
import { required, max } from '@features/userPanel/mobx/stores/validators';
import nextCreativeApi from '@features/api/nextApiService/nextCreativeApi';
import popupStore from '@context/global/mobx/popupStore';
import { useCustomerDataStore } from '@features/customerData/mobx/context/CustomerDataStoreProvider';
import isValidCommerceCustomerId from '@features/customerData/utils/isValidCommerceCustomerId';
type PropsType = {
  uuId: string;
  imageUrl: string;
  setProjectCreated: Dispatch<SetStateAction<boolean>>;
  setValueModal: Dispatch<SetStateAction<boolean>>;
};
const CreativeModalAddProject = ({
  uuId,
  imageUrl,
  setProjectCreated,
  setValueModal
}: PropsType) => {
  const {
    t
  } = useTranslation(['common']);
  const customerDataStore = useCustomerDataStore();
  const [buttonActive, setButtonActive] = useState(true);
  const modalForm = new FormState({
    modalName: new FieldState<string>('').validators(required(), max(100)),
    modalDesc: new FieldState<string>('').validators(required(), max(200))
  });
  const resolveCustomerId = async (): Promise<string | null> => {
    if (isValidCommerceCustomerId(customerDataStore.id)) {
      return customerDataStore.id;
    }
    await customerDataStore.getCustomerFromSession();
    if (isValidCommerceCustomerId(customerDataStore.id)) {
      return customerDataStore.id;
    }
    await customerDataStore.fetchAndPopulateCustomerDataStore();
    return isValidCommerceCustomerId(customerDataStore.id) ? customerDataStore.id : null;
  };
  const saveCreative = async () => {
    const name = await modalForm.$.modalName.validate();
    const desc = await modalForm.$.modalDesc.validate();
    if (!name.hasError && !desc.hasError) {
      setButtonActive(false);
      const customerId = await resolveCustomerId();
      if (!customerId) {
        popupStore.pushPopup({
          message: t('alerts.header'),
          type: 'error'
        });
        setButtonActive(true);
        return;
      }
      const data = await nextCreativeApi.saveCreativeProject(customerId, uuId, name.value, desc.value, imageUrl);
      if (data.error) {
        popupStore.pushPopup({
          message: t('alerts.creative.add'),
          type: 'error'
        });
        setValueModal(false);
        setButtonActive(true);
      } else {
        setProjectCreated(true);
        setButtonActive(true);
      }
    } else {
      setButtonActive(true);
    }
  };
  return <div sx={styles.creativeModal}>
      <Input field={modalForm.$.modalName} placeholder={t('creative.modal.name')} maxLength={100} bottomDescription={t('creative.modal.nameBottomDescription')} />
      <Textarea field={modalForm.$.modalDesc} placeholder={t('creative.modal.description')} maxLength={200} bottomDescription={t('creative.modal.descriptionBottomDescription')} />
      <div sx={styles.acceptButton}>
        <Button size="small" variant="default" disabled={!buttonActive} fullWidth variantColor="dark" onClick={() => saveCreative()}>
          {t('creative.modal.button.save')}
        </Button>
      </div>
    </div>;
};
export default observer(CreativeModalAddProject);